import { render, staticRenderFns } from "./ques-upload.vue?vue&type=template&id=62edf500&scoped=true"
import script from "./ques-upload.vue?vue&type=script&lang=js"
export * from "./ques-upload.vue?vue&type=script&lang=js"
import style0 from "./ques-upload.vue?vue&type=style&index=0&id=62edf500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62edf500",
  null
  
)

export default component.exports